import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SelectOption } from '../../../../models/main.model';

export function useCommercialAndServiceRoomTypeOptions(): SelectOption[] {
  const { t } = useTranslation();

  return useMemo(
    () =>
      ['z witryną', 'bez witryny'].map((item) => ({
        label: t(`FORMS.OFFER_ADD.COMMERCIAL_ROOM_TYPE.${item.toUpperCase()}`),
        value: item,
      })),
    [t]
  );
}
